import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { utilities } from "@/scripts/common/utilities"
import settings from "@/scripts/common/settings"
import { refreshAllControllers, addScrollController } from "@/scripts/common/api/scrolltrigger.services"
gsap.registerPlugin(ScrollTrigger)
gsap.registerPlugin(ScrollToPlugin)

export const Scroll = (function () {
    class Spy {
        constructor(spyItem) {
            this.$spy = spyItem
            this.$target = this.$spy.dataset.target ? document.querySelector(this.$spy.dataset.target) : null
            this.active = false
            this.scrollController = null
            this.scrollOptions = {
                trigger: this.$target,
                start: 'top center',
                end: 'bottom center',
                toggleClass: {
                    targets: this.$spy,
                    className: 'active'
                }
            }

            this.events = []

            this.init()
        }

        init() {
            this.buildEvents()
            this.addToggleCallBack()
            this._addEventListener()
        }

        updateOptions(options) {
            this.scrollOptions = Object.assign(this.scrollOptions, options)
        }

        buildEvents() {
            this.events['targetUpdate'] = new CustomEvent('targetUpdate', {
                bubbles: true,
                detail: {
                    isActive: () => this.active
                }
            })
        }

        refresh() {
            if(this.scrollController) this.scrollController.refresh()
        }

        addToggleCallBack() {
            this.updateOptions({
                onToggle: self => {
                    this.active = self.isActive ? true : false
                    this.$spy.dispatchEvent(this.events['targetUpdate'])
                }
            })
        }

        _addEventListener() {
            if (this.$target) this.scrollController = ScrollTrigger.create(this.scrollOptions)
            if (this.scrollController) addScrollController(this.scrollController)

            this.$target.addEventListener('UIFilterUpdated', () => this.refresh())
            this.$target.addEventListener('panelOpen', () => this.refresh())
            this.$target.addEventListener('panelClose', () => this.refresh())
        }
    }

    class ScrollTo {
        constructor(item) {
            this.$trigger = item
            this.$target = document.querySelector(this.$trigger.getAttribute("href")) || null
            this.options = {
                duration: 0.4,
                ease: 'power2.inOut'
            }

            this.init()
        }

        init() {
            this._addEventListener()
        }

        goToTarget() {
            gsap.to(window, {
                duration: this.options.duration,
                scrollTo: {
                    y: this.$target,
                    offsetY: 150
                },
                ease: this.options.ease
            })
        }

        // Callbacks
        onClick(e) {
            e.preventDefault()
            this.goToTarget()
        }

        _addEventListener() {
            if (this.$target) this.$trigger.addEventListener('click', (e) => this.onClick(e))
        }
    }

    return {
        Spy,
        ScrollTo
    }
})()